import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			width: '100%',
			marginBottom: theme.spacing(2),
			textAlign: 'center',
			color: 'inherit',
			wordWrap: 'break-word',
			minWidth: 'unset !important',
			[theme.breakpoints.down(740)]: {
				textAlign: 'left',
				marginBottom: 0,
				width: 1,
				flexGrow: 1,
				marginLeft: theme.spacing(2),
			},
		},
	}),
	{ name: 'Questions-AnswerTypes-EditableLabel' },
)

export default useStyles
